// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { CatalogueProductFragmentDoc } from '../../catalogueProduct.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../../../router/fragments/jewelleryLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../../../components/rings/MetalVariations.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { ProductGalleryFragmentDoc } from '../../../../../components/layout/gallery/ProductGallery.generated';
import { ProductAnalyticsFragmentDoc } from '../../../../../views/product/composables/analytics/useProductAnalytics.generated';
import { ProductPageMetaFragmentDoc } from '../../../../../views/product/composables/useProductPageMeta.generated';
import { JewelleryDesignStyleLabelFragmentDoc, JewelleryNecklaceProductStyleLabelFragmentDoc, JewelleryEarringsProductStyleLabelFragmentDoc, JewelleryBraceletProductStyleLabelFragmentDoc, JewelleryRingProductStyleLabelFragmentDoc } from '../../../../../views/product/jewellery/Jewelleries.generated';
import { TaxSnippetFragmentDoc } from '../../../../../components/rings/TaxSnippet.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../../../components/rings/DeliveryTimeframe.generated';
import { RingSizeFragmentDoc } from '../fragments/ringSize.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../fragments/recommendedRingSize.fragment.generated';
export const JewelleryFragmentDoc = gql`
    fragment jewellery on CatalogueJewellery {
  ...catalogueProduct
  ...productGallery
  ...productAnalytics
  ...productPageMeta
  engravingDisabled
  designStyles {
    ...jewelleryDesignStyleLabel
  }
  gemstones {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  salePrice(region: $region, currency: $currency) {
    total {
      ...money
    }
    ...taxSnippet
  }
  ... on CatalogueJewelleryNecklace {
    translation(locale: $locale) {
      description
      seoText
    }
    necklaceProductStyles: productStyles {
      ...jewelleryNecklaceProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(region: $region, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
  }
  ... on CatalogueJewelleryEarrings {
    translation(locale: $locale) {
      description
      seoText
    }
    earringsProductStyles: productStyles {
      ...jewelleryEarringsProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(region: $region, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
  }
  ... on CatalogueJewelleryBracelet {
    translation(locale: $locale) {
      description
      seoText
    }
    braceletProductStyles: productStyles {
      ...jewelleryBraceletProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(region: $region, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
  }
  ... on CatalogueJewelleryRing {
    translation(locale: $locale) {
      description
      seoText
    }
    jewelleryRingProductStyles: productStyles {
      ...jewelleryRingProductStyleLabel
    }
    firstAvailableDeliveryDateHasEngraving: firstAvailableDeliveryDate(
      region: $region
      hasEngraving: true
    ) {
      ...deliveryTimeframe
    }
    firstAvailableDeliveryDate(region: $region, hasEngraving: false) {
      ...deliveryTimeframe
    }
    variations {
      ...metalVariation
      ...jewelleryLink
    }
    sizes(region: $region) {
      ... on RingSize {
        ...ringSize
      }
      ... on RecommendedRingSize {
        ...recommendedRingSize
      }
    }
  }
}
    ${CatalogueProductFragmentDoc}
${ProductGalleryFragmentDoc}
${ProductAnalyticsFragmentDoc}
${ProductPageMetaFragmentDoc}
${JewelleryDesignStyleLabelFragmentDoc}
${MoneyFragmentDoc}
${TaxSnippetFragmentDoc}
${JewelleryNecklaceProductStyleLabelFragmentDoc}
${DeliveryTimeframeFragmentDoc}
${MetalVariationFragmentDoc}
${JewelleryLinkFragmentDoc}
${JewelleryEarringsProductStyleLabelFragmentDoc}
${JewelleryBraceletProductStyleLabelFragmentDoc}
${JewelleryRingProductStyleLabelFragmentDoc}
${RingSizeFragmentDoc}
${RecommendedRingSizeFragmentDoc}`;